import {hash} from 'hash-it';

/**
 * The hash has to ignore key order: `useHeaderBulkTransformCacheKey` and
 * `duplicateInitialDataByParams` build the same params in different orders and
 * must land on the same cache key.
 */
export function createUniqueKeyFromObject(object: object) {
  return hash(object);
}
